import { Route } from '@angular/router';

import { ShippingComponent } from './components/shipping/shipping.component';

const ROUTES: Route[] = [
  {
    path: '',
    component: ShippingComponent,
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

export const SHIPPING_ROUTES = async () => ROUTES;
